(function () {
  var params = new URLSearchParams(window.location.search);
  var keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];
  var stored = {};

  keys.forEach(function (key) {
    var value = params.get(key);
    if (value) {
      stored[key] = value;
      try {
        window.localStorage.setItem("khuloud_" + key, value);
      } catch (error) {}
    } else {
      try {
        value = window.localStorage.getItem("khuloud_" + key);
        if (value) stored[key] = value;
      } catch (error) {}
    }
  });

  function addCartAttributes(form) {
    if (!form || !Object.keys(stored).length) return;
    Object.keys(stored).forEach(function (key) {
      var name = "attributes[" + key + "]";
      if (form.querySelector('[name="' + name + '"]')) return;
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = stored[key];
      form.appendChild(input);
    });
  }

  document.addEventListener("submit", function (event) {
    addCartAttributes(event.target);
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('form[action*="/cart/add"], form[action="/cart"]').forEach(addCartAttributes);
  });
})();
